import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');
require('./userHandling.less');

class UserHandlingController {
    user: any = {languageCode: 'nb-NO', resetPasswordRequired: false};
    originalUser;
    isUpdateState: boolean;
    authorities: Array<any>;
    allAuthorities:Array<any>;
    private modalInstance;
    userPassword:String;
    userForm:any;
    tableDefinition:Array<any>;

    constructor(private toastService, private Users, private UserAuthorities, private User){}
    $onInit: Function = ( () => {
        if(this.originalUser){
            this.isUpdateState = true;
            this.user = angular.copy(this.originalUser);
            this.setEnabledAuthorities();
        }
        else{
            this.authorities =[];
        }
    });

    createUser(){
        if(this.userForm.$valid){
            this.Users.createUser(this.user).$promise.then(
                (success)=> this.updateAuthorities(),
                (error)=>{
                    if(error.data.message === "This user is already registered."){
                        this.toastService.showSimpleToast("Brukernavnet finnes fra før", 3000);
                    }
                    else if(error.data.message === "This user is already registered, but has since been disabled."){
                        this.toastService.showSimpleToast("Brukernavnet tilhører en deaktivert bruker.", 3000);
                    }
                    else{
                        this.toastService.parseError(error);
                    }
                }
            );
        }
    }

    updateUser(){
        if(this.userForm.$dirty && this.userForm.$valid){
            if(this.userPassword){
                this.User.changePassword({newPassword:this.userPassword, username:this.user.username}).$promise.then(
                    (success)=> {},
                    (error)=> this.toastService.parseError(error)
                );
            }
            this.Users.updateUser({username:this.user.username},this.user).$promise.then(
                (success)=> this.updateAuthorities(),
                (error)=> this.toastService.parseError(error)
            );
        }else {
            if(this.userForm.$valid){
                this.toastService.showSimpleToast("Ingen endringer utført", 3000);
                this.closeModal();
            }
        }
    }

    updateAuthorities(){
        _.forEach(this.authorities, (auth)=> auth.enabled = true);
        this.UserAuthorities.updateAuthorities({username:this.user.username}, this.authorities).$promise.then(
            ()=>{
                if(this.isUpdateState){
                    this.toastService.showSimpleToast("Brukeren har blitt oppdatert!", 3000);
                }
                else{
                    this.toastService.showSimpleToast("Brukeren har blitt opprettet!", 3000);
                }
                this.modalInstance.hide();
            },
            (error)=> this.toastService.parseError(error)
        );
    }

    setEnabledAuthorities(){
        this.authorities = _.filter(this.allAuthorities, (auth)=>{
            return _.indexOf(this.user.authorities, auth.name) > -1;
        });
    }

    closeModal(){
        this.modalInstance.cancel();
    }
}

class UserHandlingOptions implements ng.IComponentOptions {
    controller = 'rkcUserHandlingController';
    controllerAs = "c";
    template:any = require('./userHandling.html');
    bindings: any = {
        originalUser:'=',
        modalInstance:'=',
        allAuthorities: '=',
        authDef: '='
    };
}

rkcApp.controller("rkcUserHandlingController", ['toastService','Users', 'UserAuthorities','User',
    function (toastService, Users, UserAuthorities, User) {
        return new UserHandlingController(toastService, Users, UserAuthorities, User);
    }])
    .component("rkcUserHandling", new UserHandlingOptions())
;


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/users/userHandling/userHandling.ts
 **/